/* This file checks if any steps needs to be revised before you can download your will. 
   If we remove functionality from the system that affects the details in the will, testators
   need to go back to that step and update the data to follow the new implementation.
   With this we can check if any legacy values have been selected for testators and mark
   the corrolating step to be revised. 
 */

import { getAge } from '../constants/js/people.js';

export default {
  anyStepsToRevise(testator) {
    let revises = [];
    for (let i = 1; i < 8; i++) {
      revises.push(this.reviseStep(testator, i));
    }

    return revises.includes(true);
  },
  reviseStep(testator, step) {
    if (step === 1) {
      return this.step_1_missing_identity_number(testator);
    }
    if (step === 2) {
      return this.step_2_internal_executor_updates_to_revise(testator);
    }
    if (step === 5) {
      return this.step_5_remainder_of_estate(testator);
    }
    if (step === 6) {
      return this.step_6_living_will_decision_maker_issues(testator);
    }
    return false;
  },
  remainderOfEstateNeedsReview(testator) {
    return (testator.remainderOfEstateReviewReasons || []).length > 0;
  },
  remainderOfEstateChanged(testator) {
    return (testator.remainderOfEstateReviewReasons || []).some(
      reason => reason !== 'alternatives_outdated'
    );
  },
  step_5_remainder_of_estate(testator) {
    if (this.remainderOfEstateNeedsReview(testator)) {
      return true;
    }

    const remainderOfEstate = testator.remainderOfEstate;
    if (!remainderOfEstate) {
      return false;
    }

    // Updates introduced in this ticket: https://height.app/rXjSZtGSUQ/working-board-view-f6fcdf0285da46d1ae4473346bdea333/T-48
    if (
      ['SPOUSE_AND_CHILDREN', 'CHILDREN'].includes(
        remainderOfEstate.distribution
      )
    ) {
      return true;
    }
    return ['UNBORN_CHILDREN', 'SPECIFIC_PEOPLE'].includes(
      remainderOfEstate.alternativeDistribution
    );
  },
  step_1_missing_identity_number(testator) {
    const earlyStatuses = ['step1', 'created', 'activated'];
    if (earlyStatuses.includes(testator.status?.toLowerCase())) {
      return false;
    }
    return !testator.identityNumber?.number;
  },
  step_6_living_will_decision_maker_issues(testator) {
    if (!testator.livingWill) {
      return false;
    }

    const decisionMaker = (testator.people || []).find(person =>
      (person.testatorRelationships || []).some(
        rel => rel.relation === 'LIVING_WILL_DECISION_MAKER'
      )
    );

    if (!decisionMaker) {
      return true;
    }

    if (decisionMaker.dateOfBirth && getAge(decisionMaker.dateOfBirth) < 18) {
      return true;
    }

    return false;
  },
  step_2_internal_executor_updates_to_revise(testator) {
    if (testator.bypassOmOnlyExecutor) {
      return false;
    }

    // Updates introduced in this ticket: https://height.app/rXjSZtGSUQ/working-board-view-f6fcdf0285da46d1ae4473346bdea333/T-143
    if ((testator.enabledFeatures || []).includes('om_only_executor')) {
      if (
        testator.executorParty !== null &&
        (testator.executorParty !== 'INTERNAL_COMPANY' ||
          testator.alternativeExecutorParty !== null)
      ) {
        return true;
      }

      const hasExecutor = testator.testatorRelationships.some(relationship => {
        if (
          relationship.relation === 'CO_EXECUTOR' ||
          relationship.relation === 'ALTERNATIVE_EXECUTOR' ||
          relationship.relation === 'EXECUTOR'
        ) {
          return true;
        }
        return false;
      });

      return hasExecutor;
    } else {
      return false;
    }
  },
};
